// --- NEW FILE: apps/website/src/stores/ui/sprintEditor.slice.ts ---

import type { StateCreator } from 'zustand';
import type { Sprint, UUID } from '@dopomogai/types';
import { NEW_SPRINT_TEMPLATE } from './templates';

export interface SprintEditorState {
  isOpen: boolean;
  editingSprint: Sprint | null;
}

export interface SprintEditorSlice {
  sprintEditor: SprintEditorState;
  openSprintEditor: (sprint: Sprint | null, projectId: UUID) => void;
  closeSprintEditor: () => void;
  updateEditingSprint: (data: Partial<Omit<Sprint, 'id' | 'project_id'>>) => void;
}

export const createSprintEditorSlice: StateCreator<SprintEditorSlice, [], [], SprintEditorSlice> = (set) => ({
  sprintEditor: {
    isOpen: false,
    editingSprint: null,
  },
  openSprintEditor: (sprint, projectId) => set({
    sprintEditor: {
      isOpen: true,
      editingSprint: sprint ? { ...sprint } : NEW_SPRINT_TEMPLATE(projectId),
    }
  }),
  closeSprintEditor: () => set({ sprintEditor: { isOpen: false, editingSprint: null } }),
  updateEditingSprint: (data) => set((state) => {
    if (!state.sprintEditor.editingSprint) return state;
    return {
      sprintEditor: {
        ...state.sprintEditor,
        editingSprint: { ...state.sprintEditor.editingSprint, ...data },
      }
    };
  }),
});